import classNames from 'classnames';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

import { day_cz_take_allreward } from '@/api/hall';
import { implog } from '@/api/implog';
import icon_checked from '@/assets/icon/icon_checked.webp';
import adotado from '@/assets/modal/agotado.webp';
// import topBg from '@/assets/modal/daily_package_bg.webp';
import Button from '@/components/button';
import BlurryLoadingImage from '@/components/progressive-img';
import useRecharge from '@/hooks/useRecharge';
import { modalStore } from '@/stores/modal';
import globalStore from '@/stores/store';
import { toast } from '@/utils/toast';

import styles from './styles.module.less';

const DailyPackageModal = () => {
  const { dailyPackageConfig, dailyPackageAwardmoney, dailyPackageBuyCount } = modalStore;
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    implog('daily_package_modal_show');
  }, []);

  useEffect(() => {
    if (dailyPackageConfig.length > 0) {
      const nobuy = dailyPackageConfig.find(item => item.hasbuy !== 1);
      setAmount(nobuy?.payfee || 0);
    }
  }, [dailyPackageConfig]);

  const { runRecharge } = useRecharge();
  return (
    <div className={styles.container}>
      <BlurryLoadingImage
        loading="lazy"
        src={`${window?.imgPrefix || ''}/img/modal/daily_package_bg.webp`}
        className={styles.bg}
      />
      <div className={styles.head}>Only for {dayjs().format('DD/MM')}</div>
      <div className={styles.main}>
        <div className={styles.thead}>
          <div>Deposit</div>
          <div>Bonus</div>
          <div>Total Received</div>
        </div>
        <div style={{ position: 'relative' }}>
          {dailyPackageConfig.map(({ rid, rate, payfee, score, hasbuy }) => (
            <div
              key={rid}
              className={classNames(styles.tbody_tr, {
                [styles.active_tr]: payfee === amount,
                [styles.disabled]: hasbuy === 1,
                [styles.not_show_agotado]: dailyPackageBuyCount >= dailyPackageConfig.length
              })}
              onClick={() => {
                if (hasbuy === 1) return;
                setAmount(payfee);
              }}
            >
              <div>$ {payfee}</div>
              <div style={{ whiteSpace: 'nowrap' }}>+{rate}%</div>
              <div className={styles.last_child}>{score}</div>

              <div className={styles.checked}>
                <BlurryLoadingImage loading="lazy" src={icon_checked} />
              </div>
            </div>
          ))}
          {dailyPackageBuyCount >= dailyPackageConfig.length && (
            <div className={styles.agotado}>
              <BlurryLoadingImage loading="lazy" src={adotado} />
            </div>
          )}
        </div>
        {dailyPackageBuyCount < dailyPackageConfig.length && (
          <Button
            block
            size="large"
            type="success"
            disabled={dailyPackageBuyCount >= dailyPackageConfig.length}
            style={{ marginTop: '0.5rem' }}
            onClick={() => {
              implog('daily_package_modal_click', amount.toString());
              runRecharge({
                amount,
                cztype: 'daily'
              });
            }}
          >
            Deposit ${amount}
          </Button>
        )}

        <div className={styles.foot}>
          <div className={styles.foot_left}>
            <div>Deposit all items and earn an </div>
            <div>
              extra <span>$ {dailyPackageAwardmoney}</span> bonus
            </div>
          </div>
          <Button
            disabled={dailyPackageBuyCount < dailyPackageConfig?.length}
            onClick={async () => {
              await day_cz_take_allreward();
              await globalStore.fetchBalance();
              modalStore.closeShowDailyPackage();
              toast('Se recibió con éxito');
              modalStore.closeModal();
            }}
            type="success"
            size="small"
          >
            Receive
          </Button>
        </div>
      </div>
      <div className={styles.tips}>Deposit any amount and get a bonus $0.5-1</div>
    </div>
  );
};

export default DailyPackageModal;
